<template>

    <div class="column col-12 col-mx-auto">
                        


        <div class="wrap">
            
        
            <h3 class="entry-title" > <i class="fas fa-check"></i> Dziękujemy za cierpliwość, <br> z radością możemy zaproponować Ci kwotę: </h3>  


            <h1 class="offered text-center" v-dynamic="formatedAmount"></h1>


            <div class="d-flex justify-content-center">
                <div class="col-lg-4 mb-5 order-2 order-lg-2">          

                     <div class="proposal-details side-col sticky">
                      

                      <div class="container">
                        <div class="row ">
                          <div class="col-sm-12 loan-details py-4 px-4">
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Kwota:
                                      </div>
                                      <div class="col col-auto">
                                        {{loanAmount}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Miesięczna rata:
                                      </div>
                                      <div class="col col-auto">
                                        {{installmentAmount}} zł
                                      </div>
                                </div>                                
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Okres:
                                      </div>
                                      <div class="col col-auto">
                                        {{loanTenor}} {{ tenorSign == 'd' ? 'dni' : 'mc' }}
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Data spłaty:
                                      </div>
                                      <div class="col col-auto">
                                        {{finishDate}}
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Prowizja:
                                      </div>
                                      <div class="col col-auto">
                                        {{service}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Oprocentowanie:
                                      </div>
                                      <div class="col col-auto">
                                        {{interest}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          RRSO:
                                      </div>
                                      <div class="col col-auto">
                                        {{rrso}} %
                                      </div>
                                </div>
                                <div class="row summary">
                                  <div class="col col-auto me-auto">
                                      Razem:
                                  </div>
                                  <div class="col col-auto">
                                    {{total}} zł
                                  </div>
                            </div>                          
                          </div>
                        </div>  

                        <div class="text-center"><a class="plain" href="#" @click="openModal">Formularz informacyjny</a></div>                
                      </div>               
                    
                  </div> 
              
              </div>
            </div>
    


        </div>


        <div class="text-center mt-5 mb-5">

            <a key="btn-prev"  class="form-button btn btn-outline-primary btn-lg me-2" @click="resign" ><i class="icon flaticon-left-arrow"></i> REZYGNUJĘ </a>            


            <a  key="btn-next"  class="form-button btn btn-outline-primary btn-lg me-2" @click="accept" > ZGADZAM SIĘ <i class="icon flaticon-right-arrow"></i></a>

                          
        </div>


        <!-- Modal -->
        <div  class="modal fade" ref="modal" >
          <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header container dark-bg">
                <div class="col-auto me-auto ">
                  <h3>Formularz Informacyjny</h3>
                </div>
                  <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" v-dynamic="details">
            
                </div>


                <div class="modal-footer justify-content-center">

                  <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>
                </div>

              </div>
          </div>
        </div>
        
    </div>

</template>

<script>

    import { bus } from './main';     


    export default {
     
       name: 'ZetosProposalView',



       data(){

            return {

              modal: null,

              details: '',



              waitCount: 0
              
            }
       },


       computed: {


        formatedAmount(){

          return this.formatCurrency(this.loanAmount) + ' zł';
        },


        installmentAmount(){

            return (this.total / this.loanTenor).toFixed(2);
        }
         


       },


       methods: {

        accept(){


            var page = this.$root.mainpage;


            page.isLoading = 'to może potrwać do 2 minut..,prosimy o cierpliwość..,przygotowujemy dokumenty..';
            this.waitCount = 0;



           // this.post( '/score')
            this.post( '/counteroffer', {amount: this.loanAmount})
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                  this.onWaiting();              

                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });





        },

        resign(){



            this.post( '/resign' )
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                    this.$router.push({path: 'resign'});
                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });



        },



        gotomain(){

            this.$router.push({path: '/'});
        },




        onWaiting( endpoint='application' ) {


          var page = this.$root.mainpage,
              step,


            poll = () => {

              if (this.waitCount > 60){

                page.isLoading =false;
                return;
              }

              this.waitCount++;


              this.get( '/' + endpoint )
                  .then(response => {
                   

                    if (!!response.data) {

                      step = response.data.hasOwnProperty('step') ? response.data.step : '';

    //console.log(step);

                      switch (step) {

                        case 'counteroffer':
                        case 'wait':
                          break;

                                                          

                        default:
                          page.isLoading =false;
                          this.$router.push({path: 'thankyou'});
                          return;
                      }


    //console.log(response.data)

                   
                    }
                    else {
                      console.log('status empty body');
                    }


                    // dispatch another poll request
                    page.isLoading
                      && setTimeout(poll, 3000);                



                  })
                  .catch(error => {
                   
                      // wait for timeout
                      //page.isLoading = false;
                      setTimeout(poll, 3000);

         
                      // Error 
                      if (error.response) {
                     

                      } else if (error.request) {
                        
                      } else {
                          // Something happened in setting up the request and triggered an Error
                          //console.log('Error', error.message);
                      }
                  });


            };


            // initial polling
            setTimeout(poll, 3000);
        },




        openModal(v){


         /* let tmp, rg;

          if (this.detailed.match(/^__/)){


            this.detailed.split(',').map(p => {

              tmp = p.split(':');

              if (tmp.length > 1) {

                rg = new RegExp('^'+tmp[1]);

                rg.test(v) && (this.details = this.getModalContent( tmp[0].replace(/__(.*)/, '$1') ));

              }
              else {

                this.details = this.getModalContent( tmp[0].replace(/__(.*)/, '$1') );
              }

            });
          }*/

          this.details = this.getModalContent('info_form');


          this.modal.show();



         // alert(v)
        }




       },


       created() {






/*           bus.$on('proposal_amount', (data) => {

                //this.amount = amount;

              this.setValues(data.net_amount);         


              this.finishDate = data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
    
           });*/



       },


    mounted(){


      // check if ais was completed
      if (!this.$root.mainpage.aisdone) {

        this.$router.push({path: '/client'})
      }
      else {

        this.$root.mainpage.aisdone = false;
      }



      this.modal = new bootstrap.Modal(this.$refs['modal']);


      // scroll to top
      this.pageTop();

    }



        
    }
</script>

<style scoped>


h3 i {
    color: #0bc268;
}

h1.offered {

    font-size: 3.5rem;
}


div.proposal-details {

  border-radius:3rem;
  background-color: #fff;
}


.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:center;
}

.button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}






.fade-enter-active,.fade-leave-active {
  transition: opacity 3s
}
.fade-enter,.fade-leave-active {
  opacity: 0
}


.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,.slide-fade-leave-active {
  padding-left: 10px;
  opacity: 0;
}



  .modal-dialog {
    max-width: 900px;
  
  }


  .modal-header{
    
    display:flex;

  }

  .modal-title {
    color: #fefefe;
  }

  .modal-body {
    overflow-y: auto;
  }

</style>


// WEBPACK FOOTER //
// src/ZetosProposalView.vue